import * as THREE from "three";
import gsap from "gsap";

export default class changeLight extends THREE.Object3D {
	constructor(hemiLight, dirLight, backgroundColor, fog, postition, changeBackrgound) {
		super();

		const light1 = document.getElementById("light-1");
		const light2 = document.getElementById("light-2");
		const light3 = document.getElementById("light-3");

		light1.addEventListener("click", () => selectLight(light1, changeToMorning));
		light2.addEventListener("click", () => selectLight(light2, changeToDay));
		light3.addEventListener("click", () => selectLight(light3, changeToNight));

		function selectLight(lightElement, changeLightFunction) {
			if (lightElement.classList.contains("active")) {
				return;
			}

			light1.classList.remove("active");
			light2.classList.remove("active");
			light3.classList.remove("active");

			lightElement.classList.add("active");
			changeLightFunction();
		}

		function changeLightColor(targetColor, fogColor, duration) {
			gsap.to(backgroundColor, {
				duration,
				ease: "Power1.easeOut",
				r: targetColor.r,
				g: targetColor.g,
				b: targetColor.b,
			});

			gsap.to(fog.color, {
				duration,
				ease: "Power1.easeOut",
				r: fogColor.r,
				g: fogColor.g,
				b: fogColor.b,
			});
		}

		function changeHemiLightIntensity(intensity, duration) {
			gsap.to(hemiLight, {
				duration,
				ease: "Power1.easeOut",
				intensity,
			});
		}

		function changeDirLightIntensity(intensity, duration) {
			gsap.to(dirLight, {
				duration,
				ease: "Power1.easeOut",
				intensity,
			});
		}

		function changeCameraPosition(position, duration) {
			gsap.to(postition, {
				duration,
				ease: "Power1.easeOut",
				x: position.x,
				y: position.y,
				z: position.z,
			});
		}

		function changeToMorning() {
			const targetColor = new THREE.Color(0x4DA0FF);
			const buttomColor = new THREE.Color(0xffffff);
			const fogColor = new THREE.Color(0xb2dded);
			changeCameraPosition({ x: -40, y: 10, z: 5 }, 3);
			changeHemiLightIntensity(1.0, 3);
			changeDirLightIntensity(0.7, 3);
			changeLightColor(targetColor, fogColor, 3);
			changeBackrgound(targetColor, buttomColor)
		}

		function changeToDay() {
			const targetColor = new THREE.Color(0x0077ff);
			const buttomColor = new THREE.Color(0xffffff);
			const fogColor = new THREE.Color(0xb2dded);
			changeCameraPosition({ x: -24, y: 15, z: 5 }, 3);
			changeHemiLightIntensity(1.5, 3);
			changeDirLightIntensity(2.5, 3);
			changeLightColor(targetColor, fogColor, 3);
			changeBackrgound(targetColor, buttomColor)
		}

		function changeToNight() {
			const targetColor = new THREE.Color(0x0B1026);
			const buttomColor = new THREE.Color(0x061D37);
			const fogColor = new THREE.Color(0x061D37);
			changeHemiLightIntensity(0.4, 3);
			changeDirLightIntensity(0.3, 3);
			changeLightColor(targetColor, fogColor, 3);
			changeCameraPosition({ x: 40, y: 10, z: 5 }, 3);
			changeBackrgound(targetColor, buttomColor)
		}

		// Set the default light
		selectLight(light1, changeToMorning);
	}
}